import React from 'react';
import MediaQuery from "react-responsive";
import SidebarDesktop from "components/sidebar/SidebarDesktop";
import SidebarMobile from "components/sidebar/SidebarMobile";

const JobbizGame = () => {
  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar - rendue sur tous les écrans */}
      <SidebarDesktop/>
      {/* Navbar mobile - uniquement sur mobile */}
      <MediaQuery maxWidth={768}><SidebarMobile/></MediaQuery>
      {/* Content area */}
      <div className="flex flex-col flex-1 overflow-hidden">
        <div className="w-full h-full">
          <iframe
            src="https://game-admin-jobbiz.vercel.app/"
            className="w-full h-full border-0"
            title="Jobbiz Game"
            allow="fullscreen"
          />
        </div>
      </div>
    </div>
  );
};

export default JobbizGame;

